import { create } from 'zustand';
import { DateRange } from '@mui/x-date-pickers-pro';
import dayjs, { Dayjs } from 'dayjs';

interface DateRangeStore {
  adManagementFilterDateRange: [string | null, string | null];
  setAdManagementFilterDateRange: (range: [string | null, string | null]) => void;
}

export const useAdManagementFilterDateStore = create<DateRangeStore>((set) => ({
  adManagementFilterDateRange: [null, null],
  setAdManagementFilterDateRange: (range) => set({ adManagementFilterDateRange: range }),
}));

interface FilterDateState {
  dashboardFilterDateRange: DateRange<Dayjs>,
  setDashboardFilterDateRange: (newDateRange: DateRange<Dayjs>) => void,
}

export const useDashboardFilterDateStore = create<FilterDateState>((set) => ({
  dashboardFilterDateRange: [
    localStorage.getItem('from') ? dayjs(localStorage.getItem('from')) : null,
    localStorage.getItem('to') ? dayjs(localStorage.getItem('to')) : null,
  ],
  setDashboardFilterDateRange: (newDateRange) => {
    if (newDateRange) {
      localStorage.setItem('from', newDateRange[0]?.toISOString() || '');
      localStorage.setItem('to', newDateRange[1]?.toISOString() || '');
    } else {
      localStorage.removeItem('from');
      localStorage.removeItem('to');
    }
    set({ dashboardFilterDateRange: newDateRange });
  },
}));

interface HistogramDateState {
  histogramFilterDateRange: DateRange<Dayjs>;
  setHistogramFilterDateRange: (newDateRange: DateRange<Dayjs>) => void;
  userSelected: boolean;
  setUserSelected: (value: boolean) => void;
}

export const useHistogramFilterDateStore = create<HistogramDateState>((set) => ({
  histogramFilterDateRange: [
    localStorage.getItem('from') ? dayjs(localStorage.getItem('from')) : null,
    localStorage.getItem('to') ? dayjs(localStorage.getItem('to')) : null,
  ],
  setHistogramFilterDateRange: (newDateRange) => {
    if (newDateRange) {
      localStorage.setItem('from', newDateRange[0]?.toISOString() || '');
      localStorage.setItem('to', newDateRange[1]?.toISOString() || '');
    } else {
      localStorage.removeItem('from');
      localStorage.removeItem('to');
    }
    set({ histogramFilterDateRange: newDateRange });
  },
  userSelected: false,
  setUserSelected: (value: boolean) => set({ userSelected: value }),
}));
